import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import "../components/text_display/Text_display.css";
import { businessSchemaDE, businessSchemaEN } from "../schema";

const PrivacyNotice = () => {
  const { i18n } = useTranslation();
  const currentSchema =
    i18n.language === "en" ? businessSchemaEN : businessSchemaDE;

  const handleLinkKeyDown = (e, href) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      window.location.href = href;
    }
  };

  return (
    <>
      <Helmet>
        <title>
          {i18n.language === "en"
            ? "Disclaimer - Violin Maker Jacobi"
            : "Haftungsausschluss - Geigenbau Jacobi"}
        </title>
      </Helmet>
      <script type="application/ld+json">
        {JSON.stringify(currentSchema)}
      </script>
      <div className="privacy-notice-container">
        <h1 className="privacy-header focus-highlight" tabIndex={0}>
          Haftungsausschluss
        </h1>
        <h1 className="privacy-subheader focus-highlight" tabIndex={0}>
          1. Inhalte dieser Website
        </h1>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Die Inhalte dieser Website werden mit größtmöglicher Sorgfalt
          erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der
          bereitgestellten Informationen übernimmt der Anbieter jedoch keine
          Gewähr. Als Diensteanbieter ist der Anbieter gemäß § 7 Abs. 1 DDG für
          eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
          verantwortlich. Nach §§ 8 bis 10 DDG ist der Anbieter jedoch nicht
          verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
          überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
          Tätigkeit hinweisen.
          <br />
          Die Nutzung der Inhalte der Website erfolgt auf eigene Verantwortung
          des Nutzers. Die bereitgestellten Informationen stellen insbesondere
          keine rechtliche, technische oder fachliche Beratung dar und ersetzen
          keine individuelle Beratung oder Begutachtung.
          <br />
          Namentlich gekennzeichnete Beiträge geben die Meinung des jeweiligen
          Autors und nicht immer die Meinung des Anbieters wieder.
        </p>

        <h2 className="privacy-subheader focus-highlight" tabIndex={0}>
          2. Haftung für externe Links
        </h2>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Diese Website enthält Verlinkungen zu externen Websites Dritter, auf
          deren Inhalte der Anbieter keinen Einfluss hat. Für diese fremden
          Inhalte wird daher keine Gewähr übernommen. Zum Zeitpunkt der
          erstmaligen Verlinkung wurden die externen Inhalte auf mögliche
          Rechtsverstöße überprüft; rechtswidrige Inhalte waren zu diesem
          Zeitpunkt nicht erkennbar. Eine permanente inhaltliche Kontrolle der
          verlinkten Seiten ist ohne konkrete Anhaltspunkte einer
          Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverstößen
          werden derartige Links unverzüglich entfernt.
        </p>

        <h2 className="privacy-subheader focus-highlight" tabIndex={0}>
          3. Urheberrecht
        </h2>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Die durch den Anbieter erstellten Inhalte und Werke auf dieser Website
          unterliegen dem deutschen Urheberrecht. Beiträge Dritter sind als
          solche gekennzeichnet. Die Vervielfältigung, Bearbeitung, Verbreitung
          und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts
          bedürfen der vorherigen schriftlichen Zustimmung des jeweiligen
          Rechteinhabers. Downloads und Kopien dieser Seite sind nur für den
          privaten, nicht kommerziellen Gebrauch gestattet. Dies gilt
          insbesondere für Vervielfältigung, Bearbeitung, Übersetzung,
          Einspeicherung, Verarbeitung bzw. Wiedergabe von Inhalten in
          Datenbanken oder anderen elektronischen Medien und Systemen. Inhalte
          und Rechte Dritter sind dabei als solche gekennzeichnet. Die
          unerlaubte Vervielfältigung oder Weitergabe einzelner Inhalte oder
          kompletter Seiten ist nicht gestattet und strafbar. Lediglich die
          Herstellung von Kopien und Downloads für den persönlichen, privaten
          und nicht kommerziellen Gebrauch ist erlaubt.
          <br />
          Die Darstellung dieser Website in fremden Frames ist nur mit
          schriftlicher Erlaubnis zulässig.
        </p>

        <h2 className="privacy-subheader focus-highlight" tabIndex={0}>
          4. Datenschutz
        </h2>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Weitere Informationen zum Thema Datenschutz finden Sie
        </p>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          <a
            href={
              i18n.language === "en" ? "/en/privacy_notice" : "/privacy_notice"
            }
            className="focus-highlight"
            tabIndex={0}
            aria-label="Datenschutzerklärung aufrufen"
            onKeyDown={(e) => handleLinkKeyDown(e, "/privacy_notice")}
          >
            hier
          </a>
        </p>

        <h2 className="privacy-subheader focus-highlight" tabIndex={0}>
          5. Keine Vertragsbegründung
        </h2>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Durch die Nutzung dieser Website kommt kein Vertragsverhältnis
          zwischen dem Nutzer und dem Anbieter zustande. Ein Vertragsschluss
          erfolgt ausschließlich über ausdrücklich angebotene Leistungen und
          separate Vereinbarungen.
        </p>

        <h2 className="privacy-subheader focus-highlight" tabIndex={0}>
          6. Hinweis zu Geschützten Markennamen und Logos
        </h2>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Die Verwendung von geschützten Markennamen, Handelsnamen,
          Gebrauchsmuster und Markenlogos auf dieser Webseite dient als
          illustrativer Hinweis und stellt daher keine Urheberrechts-Verletzung
          dar. Es gelten die entsprechenden gesetzlichen Bestimmungen. Die
          verwendeten Markennamen und -logos sind Eigentum der Hersteller und
          unterliegen deren Copyright Bestimmungen.
        </p>

        <h2 className="privacy-subheader focus-highlight" tabIndex={0}>
          7. Hinweis zum Urheberrecht & Copyright
        </h2>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Alle Rechte vorbehalten. Die durch die Seitenbetreiber erstellten
          Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
          Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede
          Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen
          der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
          Downloads und Kopien dieser Seite sind nur für den privaten, nicht
          kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite
          nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter
          beachtet. Insbesondere werden Inhalte Dritter als solche
          gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung
          aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei
          Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte
          umgehend entfernen.
        </p>
        <h2 className="privacy-subheader focus-highlight" tabIndex={0}>
          8. Rechtswirksamkeit dieses Haftungsausschlusses
        </h2>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Dieser Haftungsausschluss ist als Teil des Internetangebotes zu
          betrachten, von dem aus auf diese Seite verwiesen wurde. Sofern Teile
          oder einzelne Formulierungen dieses Textes der geltenden Rechtslage
          nicht, nicht mehr oder nicht vollständig entsprechen sollten, bleiben
          die übrigen Teile des Dokumentes in ihrem Inhalt und ihrer Gültigkeit
          davon unberührt.
        </p>
        <h2 className="privacy-subheader focus-highlight" tabIndex={0}>
          9. Besondere Nutzungsbedingungen
        </h2>
        <p className="privacy-text focus-highlight" tabIndex={0}>
          Sofern für einzelne Nutzungen dieser Website besondere Bedingungen gelten, wird an entsprechender Stelle ausdrücklich darauf hingewiesen. In diesem Fall gelten die jeweiligen besonderen Nutzungsbedingungen ergänzend zu diesem Haftungsausschluss.
        </p>
      </div>
    </>
  );
};

export default PrivacyNotice;
